import { SET_REHYDRATED } from './';

export function setRehydrated () {
  return {
    type: SET_REHYDRATED
  };
}
